var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logout"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    clipPath: "url(#clip-Logout)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13052",
    "data-name": "Group 13052",
    transform: "translate(0.557 0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13053",
    "data-name": "Group 13053",
    transform: "translate(0.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M9.133.123A7.678,7.678,0,0,1,14.766,4.4a.756.756,0,1,1-1.357.668A6.287,6.287,0,0,0,11.807,3,6.114,6.114,0,0,0,7.27,1.542a6.245,6.245,0,1,0,6.053,9.073c.03-.058.058-.118.09-.175a.759.759,0,0,1,1.349.7,7.549,7.549,0,0,1-1.223,1.816,7.717,7.717,0,0,1-4.719,2.5,12.885,12.885,0,0,1-2.748-.116A7.77,7.77,0,0,1,.12,9.118a9.584,9.584,0,0,1,.1-3.165A7.763,7.763,0,0,1,6.412.119,11.12,11.12,0,0,1,9.133.123Z",
    transform: "translate(-0.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M109.385,117.629h-.192q-2.039,0-4.079,0a.758.758,0,1,1-.009-1.514c.869,0,1.739,0,2.608,0h1.664c-.055-.06-.089-.1-.127-.138q-.471-.472-.943-.944a.76.76,0,1,1,1.073-1.071q.919.914,1.833,1.834a1.465,1.465,0,0,1,0,2.16q-.925.93-1.855,1.854a.73.73,0,0,1-.78.192.751.751,0,0,1-.3-1.251c.328-.33.657-.658.986-.987.034-.034.066-.071.122-.132",
    transform: "translate(-100.139 -109.102)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.42b23e1d5b44e592cf98e733c99212b3.svg";
export { ForwardRef as ReactComponent };